import * as React from 'react';

function SvgIceHockey(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M4 4h16v16H4z" />
        <path
          d="M18.5 4a1.502 1.502 0 011.267 2.303l-8.1 12.768c-.37.582-1 .929-1.688.929H6c-1.103 0-2-.897-2-2s.897-2 2-2h2.944L17.29 4.614A1.502 1.502 0 0118.5 4zM7 17H6c-.55 0-1 .448-1 1s.45 1 1 1h1v-2zm4.142-2.309L9.75 16.592c-.188.256-.49.408-.806.408H8v2h1.978c.344 0 .66-.174.845-.465l1.785-2.815-1.466-1.029zm1.452-1.981l-.861 1.174 1.412.991.739-1.165-1.29-1zM8.5 11a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h4zM8 12H5v1h3v-1zm10.5-7a.496.496 0 00-.403.205l-4.911 6.697 1.237.959 4.5-7.094A.5.5 0 0018.5 5z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgIceHockey;
